import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Comprobante a tamaño grande.
 *
 * La miniatura del listado mide 2rem: sirve para saber que hay comprobante, no
 * para leer un ticket. Esto no duplica el modal de revisión, que además decide y
 * exige motivo: aquí sólo se mira, así que se abre también sobre gastos ya
 * resueltos y desde el desglose de precio del detalle de servicio.
 */
@Component({
  selector: 'app-expense-receipt-modal',
  templateUrl: './expense-receipt-modal.component.html',
  styleUrls: ['./expense-receipt-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpenseReceiptModalComponent {
  @Input({ required: true }) url!: string;

  /**
   * La URL del blob puede haber caducado, o el fichero no ser una imagen: los
   * comprobantes que se suben desde logistics admiten PDF y un `img` no lo pinta.
   * En ambos casos queda el enlace para abrirlo en una pestaña.
   */
  protected hasError = false;

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly cdr: ChangeDetectorRef
  ) {}

  protected onError(): void {
    this.hasError = true;
    this.cdr.markForCheck();
  }

  protected close(): void {
    this.activeModal.dismiss();
  }
}
